export default {
    // 中文
    zhCN: {
        part_number: '零件号',
        ECU_name: 'ECU名称(中文)',
        ECU_name_en: 'ECU名称(英文)',
        modelID: '模块ID',
    },
    // 英语
    enUS: {
        part_number: 'Part Number',
        ECU_name: 'ECU Name (Chinese)',
        ECU_name_en: 'ECU Name (English)',
        modelID: 'Module ID',
    },
    // 德语
    deDE: {
        part_number: 'Teilenummer',
        ECU_name: 'ECU Name (Chinesisch)',
        ECU_name_en: 'ECU Name (Englisch)',
        modelID: 'Modul-ID',
    },
    // 法语
    frFR: {
        part_number: 'Numéro de Pièce',
        ECU_name: 'Nom de l\'ECU (Chinois)',
        ECU_name_en: 'Nom de l\'ECU (Anglais)',
        modelID: 'ID du Module',
    },
    // 意大利语
    itIT: {
        part_number: 'Numero di Parte',
        ECU_name: 'Nome ECU (Cinese)',
        ECU_name_en: 'Nome ECU (Inglese)',
        modelID: 'ID Modulo',
    },
    // 荷兰语
    nlNL: {
        part_number: 'Onderdeelnummer',
        ECU_name: 'ECU Naam (Chinees)',
        ECU_name_en: 'ECU Naam (Engels)',
        modelID: 'Module ID',
    },
    // 越南语
    viVN: {
        part_number: 'Số Phần',
        ECU_name: 'Tên ECU (Tiếng Trung)',
        ECU_name_en: 'Tên ECU (Tiếng Anh)',
        modelID: 'ID Mô-đun',
    },
    // 西班牙语
    esES: {
        part_number: 'Número de Parte',
        ECU_name: 'Nombre del ECU (Chino)',
        ECU_name_en: 'Nombre del ECU (Inglés)',
        modelID: 'ID del Módulo',
    },
    // 葡萄牙语
    ptBR: {
        part_number: 'Número da Peça',
        ECU_name: 'Nome do ECU (Chinês)',
        ECU_name_en: 'Nome do ECU (Inglês)',
        modelID: 'ID do Módulo',
    },
    // 波兰语
    plPL: {
        part_number: 'Numer Części',
        ECU_name: 'Nazwa ECU (Chiński)',
        ECU_name_en: 'Nazwa ECU (Angielski)',
        modelID: 'ID Modułu',
    },
    // 土耳其语
    trTR: {
        part_number: 'Parça Numarası',
        ECU_name: 'ECU Adı (Çince)',
        ECU_name_en: 'ECU Adı (İngilizce)',
        modelID: 'Modül Kimliği',
    },
    // 捷克语
    csCZ: {
        part_number: 'Číslo dílu',
        ECU_name: 'Název ECU (čínsky)',
        ECU_name_en: 'Název ECU (anglicky)',
        modelID: 'ID modulu',
    },
    // 匈牙利语
    huHU: {
        part_number: 'Alkatrész szám',
        ECU_name: 'ECU neve (kínai)',
        ECU_name_en: 'ECU neve (angol)',
        modelID: 'Modul azonosító',
    },
    // 俄罗斯语
    ruRU: {
        part_number: 'Номер детали',
        ECU_name: 'Название ECU (китайский)',
        ECU_name_en: 'Название ECU (английский)',
        modelID: 'ID модуля',
    },
    // 沙特阿拉伯
    arSA: {
        part_number: 'رقم القطعة',
        ECU_name: 'اسم وحدة التحكم الإلكترونية (بالصينية)',
        ECU_name_en: 'اسم وحدة التحكم الإلكترونية (بالإنجليزية)',
        modelID: 'معرف الوحدة',
    },
    // 保加利亚
    bgBG: {
        part_number: 'Номер на частта',
        ECU_name: 'Име на ECU (на китайски)',
        ECU_name_en: 'Име на ECU (на английски)',
        modelID: 'ID на модула',
    },
    // 丹麦语
    daDK: {
        part_number: 'Reservedelnummer',
        ECU_name: 'ECU-navn (kinesisk)',
        ECU_name_en: 'ECU-navn (engelsk)',
        modelID: 'Modul-ID',
    },
    // 芬兰语
    fiFI: {
        part_number: 'Osanumero',
        ECU_name: 'ECU-nimi (kiina)',
        ECU_name_en: 'ECU-nimi (englanti)',
        modelID: 'Moduulin tunnus',
    },
    // 繁体中文台湾
    zhTW: {
        part_number: '零件號',
        ECU_name: 'ECU名稱(中文)',
        ECU_name_en: 'ECU名稱(英文)',
        modelID: '模組ID',
    },
    // 克罗地亚
    hrHR: {
        part_number: 'Broj dijela',
        ECU_name: 'Naziv ECU-a (na kineskom)',
        ECU_name_en: 'Naziv ECU-a (na engleskom)',
        modelID: 'ID modula',
    },
    // 拉脱维亚
    lvLV: {
        part_number: 'Detaļas numurs',
        ECU_name: 'ECU nosaukums (Ķīniešu valodā)',
        ECU_name_en: 'ECU nosaukums (Angļu valodā)',
        modelID: 'Moduļa ID',
    },
    // 立陶宛
    ltLT: {
        part_number: 'Detalės numeris',
        ECU_name: 'ECU pavadinimas (kinų kalba)',
        ECU_name_en: 'ECU pavadinimas (anglų kalba)',
        modelID: 'Modulio ID',
    },
    // 罗马尼亚
    roRO: {
        part_number: 'Număr piesă',
        ECU_name: 'Nume ECU (chineză)',
        ECU_name_en: 'Nume ECU (engleză)',
        modelID: 'ID modul',
    },
    // 挪威博克马尔
    nbNO: {
        part_number: 'Delenummer',
        ECU_name: 'ECU-navn (kinesisk)',
        ECU_name_en: 'ECU-navn (engelsk)',
        modelID: 'Modul-ID',
    },
    // 葡萄牙语巴西
    ptBX: {
        part_number: 'Número da peça',
        ECU_name: 'Nome da ECU (chinês)',
        ECU_name_en: 'Nome da ECU (inglês)',
        modelID: 'ID do módulo',
    },
    // 瑞典语
    svSE: {
        part_number: 'Delnummer',
        ECU_name: 'ECU-namn (kinesiska)',
        ECU_name_en: 'ECU-namn (engelska)',
        modelID: 'Modul-ID',
    },
    // 斯洛伐克
    skSK: {
        part_number: 'Číslo súčiastky',
        ECU_name: 'Názov ECU (čínsky)',
        ECU_name_en: 'Názov ECU (anglicky)',
        modelID: 'ID modulu',
    },
    // 斯洛文尼亚
    slSI: {
        part_number: 'Številka dela',
        ECU_name: 'Ime ECU-ja (kitajsko)',
        ECU_name_en: 'Ime ECU-ja (angleško)',
        modelID: 'ID modula',
    },
    // 泰语
    thTH: {
        part_number: 'หมายเลขชิ้นส่วน',
        ECU_name: 'ชื่อ ECU (ภาษาจีน)',
        ECU_name_en: 'ชื่อ ECU (ภาษาอังกฤษ)',
        modelID: 'รหัสโมดูล',
    },
    // 乌克兰语
    ukUA: {
        part_number: 'Номер деталі',
        ECU_name: 'Назва ЕБК (китайською)',
        ECU_name_en: 'Назва ЕБК (англійською)',
        modelID: 'ID модуля',
    },
    // 希腊语
    elGR: {
        part_number: 'Αριθμός ανταλλακτικού',
        ECU_name: 'Όνομα ECU (Κινεζικά)',
        ECU_name_en: 'Όνομα ECU (Αγγλικά)',
        modelID: 'ID Μονάδας',
    },
    // 爱沙尼亚
    etEE: {
        part_number: 'Osa number',
        ECU_name: 'ECU nimi (hiina keeles)',
        ECU_name_en: 'ECU nimi (inglise keeles)',
        modelID: 'Mooduli ID',
    },
    // 哈萨克
    kkKZ: {
        part_number: 'Бөлшек нөмірі',
        ECU_name: 'ECU атауы (Қытай тілінде)',
        ECU_name_en: 'ECU атауы (Ағылшын тілінде)',
        modelID: 'Модульдің ID-і',
    },
    // 希伯来语
    heIL: {
        part_number: 'מספר חלק',
        ECU_name: 'שם יחידת הבקרה האלקטרונית (בסינית)',
        ECU_name_en: 'שם יחידת הבקרה האלקטרונית (באנגלית)',
        modelID: 'מזהה מודול',
    },
};
